import { configureStore } from "@reduxjs/toolkit";
import orderReducer from "../redux/order/orderSlice";
import datagridReducer from "../redux/datagrid/datagridSlice";
import tableReducer from "../redux/datagrid/tableSlice";
import tablePageReducer from "../redux/datagrid/tablePageSlice";
import synchroReducer from "../redux/synchroList/synchroSlice";
import authReducer from "../redux/auth/authSlice";
import userReducer from "../redux/auth/userSlice";
import aprDeliveryReducer from "../redux/stock/approvedDeliverySlice";
import currentTableSlice from "../redux/datagrid/currentTableSlice";
import ScanInputReducer from "../redux/pdms/scanSlice";
import TimelineReducer from "../redux/order/timelineSlice";
import purchaserReducer from '../redux/purchaser/purchaserModal'
import selectedPurchaserReducer from "../redux/purchaser/selectedPurchaser"
import ItemManagementReducer from '../redux/purchaser/itemManagement';
export const store = configureStore({
  reducer: {
    order: orderReducer,
    datagrid: datagridReducer,
    table: tableReducer,
    pageNumber: tablePageReducer,
    purchaser:purchaserReducer,
    selectedPurchaser:selectedPurchaserReducer,
    synchroNumber: synchroReducer,
    auth: authReducer,
    user: userReducer,
    aprDelivery: aprDeliveryReducer,
    currentTable: currentTableSlice,
    scanInput: ScanInputReducer,
    timeline:TimelineReducer,
    itemManagement:ItemManagementReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
